(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4515],{

/***/ 14515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_Newsletter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/colors.ts
var _types_colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/input-preset.ts
var input_preset = __webpack_require__(89419);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
;// CONCATENATED MODULE: ./src/lib/shopify-tags.ts
function getTags(param) {
    var currency = param.currency, from = param.from, country = param.country;
    var ref, ref1;
    return (ref1 = (ref = [
        "currency:".concat(currency),
        from ? "from:".concat(from) : null,
        country ? "country:".concat(country === null || country === void 0 ? void 0 : country.toUpperCase()) : null, 
    ]) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item;
    })) === null || ref1 === void 0 ? void 0 : ref1.join(",");
}

// EXTERNAL MODULE: ./src/components/Abstracts/Form/Input/index.tsx
var Input = __webpack_require__(28569);
// EXTERNAL MODULE: ./src/components/Abstracts/Form/Input/hooks/index.ts + 2 modules
var hooks = __webpack_require__(63262);
// EXTERNAL MODULE: ./src/components/Abstracts/Spinner/index.tsx
var Spinner = __webpack_require__(87407);
// EXTERNAL MODULE: ./src/components/Form/Checkbox/index.tsx + 12 modules
var Checkbox = __webpack_require__(90465);
// EXTERNAL MODULE: ./src/components/Form/ErrorList/index.tsx + 1 modules
var ErrorList = __webpack_require__(54404);
// EXTERNAL MODULE: ./src/components/Form/RecaptchaHandler/index.tsx
var RecaptchaHandler = __webpack_require__(64354);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.tsx + 17 modules
var Icons = __webpack_require__(54678);
// EXTERNAL MODULE: ./src/components/UI/RichText/index.tsx
var RichText = __webpack_require__(55071);
// EXTERNAL MODULE: ./src/components/UI/SquaredCta/index.tsx
var SquaredCta = __webpack_require__(35007);
// EXTERNAL MODULE: ./src/providers/GeolocationProvider/index.tsx + 4 modules
var GeolocationProvider = __webpack_require__(37959);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/providers/ThemeProvider/index.tsx
var ThemeProvider = __webpack_require__(5672);
// EXTERNAL MODULE: ./src/providers/TrackerProvider/index.tsx + 1 modules
var TrackerProvider = __webpack_require__(34299);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./src/@types/alert.ts
var _types_alert = __webpack_require__(34969);
// EXTERNAL MODULE: ./src/lib/handle-api.ts + 1 modules
var handle_api = __webpack_require__(16445);
// EXTERNAL MODULE: ./src/hooks/account/useShopifyUpdateCustomerLocale/index.ts
var useShopifyUpdateCustomerLocale = __webpack_require__(97859);
// EXTERNAL MODULE: ./src/hooks/useAlerts/index.ts
var useAlerts = __webpack_require__(827);
// EXTERNAL MODULE: ./src/hooks/useLang/index.ts
var useLang = __webpack_require__(7078);
// EXTERNAL MODULE: ./src/hooks/useOnMutationError/index.ts
var useOnMutationError = __webpack_require__(8414);
;// CONCATENATED MODULE: ./src/hooks/account/useShopifyNewsletterMutation/index.ts












function useShopifyNewsletterMutation(mutationOptions, setError) {
    var onMutationError = (0,useOnMutationError/* default */.Z)(setError);
    var triggerAlert = (0,useAlerts/* default */.Z)();
    var lang = (0,useLang/* default */.Z)();
    var ref = (0,useShopifyUpdateCustomerLocale/* default */.Z)({}), mutateCustomerLocale = ref.mutate;
    return (0,useMutation/* useMutation */.D)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var email, tags, _acceptsMarketing, acceptsMarketing;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = param.email, tags = param.tags, _acceptsMarketing = param.acceptsMarketing, acceptsMarketing = _acceptsMarketing === void 0 ? true : _acceptsMarketing;
                        return [
                            4,
                            (0,handle_api/* requestNextApiEndpoint */.m8)(handle_api/* SHOPIFY_CUSTOMERS_NEWSLETTER_PARAMS */.GI, {
                                payload: {
                                    email: email,
                                    lang: lang,
                                    tags: tags,
                                    acceptsMarketing: acceptsMarketing
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mutationOptions), {
        onSuccess: function(data) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            var _mutationOptions;
            triggerAlert(_types_alert/* ALERT_CODES.NEWSLETTER_SUBSCRIBE */.p.NEWSLETTER_SUBSCRIBE);
            mutationOptions === null || mutationOptions === void 0 ? void 0 : (_mutationOptions = mutationOptions).onSuccess.apply(_mutationOptions, [
                data
            ].concat((0,_to_consumable_array/* default */.Z)(rest)));
            mutateCustomerLocale({
                lang: lang,
                id: data === null || data === void 0 ? void 0 : data.id
            });
        },
        onError: function(err) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            console.log(err);
            onMutationError(err, rest, mutationOptions === null || mutationOptions === void 0 ? void 0 : mutationOptions.onError);
        }
    }));
}

// EXTERNAL MODULE: ./src/hooks/useCurrency/index.ts
var useCurrency = __webpack_require__(79298);
// EXTERNAL MODULE: ./src/hooks/useFormWithMutation/index.ts
var useFormWithMutation = __webpack_require__(73676);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/Form/Newsletter/styles.module.scss
var styles_module = __webpack_require__(44955);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Form/Newsletter/index.tsx

































var cx = bind_default().bind((styles_module_default()));
function GDPRLabels(param) {
    var gdprClassName = param.gdprClassName, gdprVisible = param.gdprVisible, gdprLabel = param.gdprLabel, gdprText = param.gdprText, gdprStyle = param.gdprStyle, uniqueId = param.uniqueId, componentColor = param.componentColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            gdprLabel && gdprVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                id: "gdpr-".concat(uniqueId),
                name: "gdpr-".concat(uniqueId),
                required: true,
                isRound: true,
                className: cx((styles_module_default()).gdpr, gdprStyle, gdprClassName, {
                    visible: gdprVisible
                }),
                theme: componentColor,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                    render: gdprLabel
                })
            }),
            gdprText && gdprVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                className: cx((styles_module_default()).gdprText, gdprStyle, gdprClassName, {
                    visible: gdprVisible
                }),
                render: gdprText
            })
        ]
    });
}
function Newsletter(_param) {
    var _form;
    var className = _param.className, formClassName = _param.formClassName, inputClassName = _param.inputClassName, inputAndGDPRWrapperClassName = _param.inputAndGDPRWrapperClassName, textSubmit = _param.textSubmit, errorsClassName = _param.errorsClassName, resultClassName = _param.resultClassName, children = _param.children, placeholder = _param.placeholder, gdprLabel = _param.gdprLabel, gdprText = _param.gdprText, gdprClassName = _param.gdprClassName, onSuccess = _param.onSuccess, fromTag = _param.fromTag, theme = _param.theme, uniqueId = _param.uniqueId, isInline = _param.isInline, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "formClassName",
        "inputClassName",
        "inputAndGDPRWrapperClassName",
        "textSubmit",
        "errorsClassName",
        "resultClassName",
        "children",
        "placeholder",
        "gdprLabel",
        "gdprText",
        "gdprClassName",
        "onSuccess",
        "fromTag",
        "theme",
        "uniqueId",
        "isInline"
    ]);
    var t = (0,lib/* useTranslate */.qM)();
    var countryISO = (0,GeolocationProvider/* useGeolocation */.ZZ)().countryISO;
    var ref = (0,react.useState)(false), gdprVisible = ref[0], setGdprVisible = ref[1];
    var currency = (0,useCurrency/* default */.Z)();
    var props = (0,hooks/* useInputPreset */.H)(input_preset/* GlobalInputPreset.Email */.Y.Email, (0,_object_spread/* default */.Z)({
        placeholder: placeholder || t(dictionary/* FORM.NEWSLETTER_EMAIL */.Yc.NEWSLETTER_EMAIL)
    }, rest));
    var componentColor = theme !== null && theme !== void 0 ? theme : _types_colors/* GlobalThemeColors.Black */.b.Black;
    var colors = (0,ThemeProvider/* useTheme */.F)().colors;
    var inputStyle = (0,StyleProvider/* useStyle */.X)({
        color: componentColor,
        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var borderStyle = (0,StyleProvider/* useStyle */.X)({
        borderColor: componentColor
    });
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        color: componentColor,
        textPreset: isInline ? text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk : text_preset/* GlobalTextPreset.Cta12GroteskRegular */.C.Cta12GroteskRegular
    });
    var submitStyle = (0,StyleProvider/* useStyle */.X)({
        borderColor: componentColor,
        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
        color: componentColor
    });
    var gdprStyle = (0,StyleProvider/* useStyle */.X)({
        color: componentColor,
        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk
    });
    var ref1 = (0,react.useState)(false), result = ref1[0], setResult = ref1[1];
    var tracker = (0,TrackerProvider/* useTracker */.Q4)();
    var ref2 = useShopifyNewsletterMutation({
        onSuccess: function() {
            tracker.emit(constants/* TRACKING_EVENTS.NEWSLETTER_SUBSCRIPTION */.Iy.NEWSLETTER_SUBSCRIPTION, {
                origin: fromTag
            });
            setResult(t(dictionary/* FORM.NEWSLETTER_SUCCESS */.Yc.NEWSLETTER_SUCCESS));
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    }, function() {
        for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
            params[_key] = arguments[_key];
        }
        return (_form = form).setError.apply(_form, (0,_to_consumable_array/* default */.Z)(params));
    }), newsletterMutation = ref2.mutate, isLoading = ref2.isLoading;
    var ref3 = (0,useFormWithMutation/* default */.Z)(newsletterMutation, null, "newsletter"), form = ref3.form, onSubmit = ref3.onSubmit;
    (0,react.useEffect)(function() {
        var ref;
        if ((form === null || form === void 0 ? void 0 : (ref = form.formState) === null || ref === void 0 ? void 0 : ref.errors) && Object.keys(form.formState.errors).length > 0) {
            setResult(false);
        }
    }, [
        form.formState
    ]);
    (0,react.useEffect)(function() {
        form.reset({
            tags: getTags({
                currency: currency,
                from: fromTag,
                country: countryISO
            })
        });
    }, [
        currency,
        countryISO,
        fromTag,
        form
    ]);
    var tags = getTags({
        currency: currency,
        from: fromTag,
        country: countryISO
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx((styles_module_default()).newsletter, className, (styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default())["".concat(componentColor, "Theme")], {
            isNotInline: !isInline
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecaptchaHandler/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: cx(formClassName, (styles_module_default()).form),
                    onSubmit: onSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: cx((styles_module_default()).input, borderStyle, inputClassName),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread/* default */.Z)({
                                    className: cx(textStyle, inputAndGDPRWrapperClassName),
                                    onFocus: function() {
                                        return setGdprVisible(true);
                                    },
                                    onChange: function() {
                                        return setResult(false);
                                    }
                                }, props)),
                                !result && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorList/* default */.Z, {
                                    className: cx((styles_module_default()).errorList, errorsClassName),
                                    name: props === null || props === void 0 ? void 0 : props.name
                                }),
                                !isInline && /*#__PURE__*/ (0,jsx_runtime.jsx)(GDPRLabels, {
                                    gdprClassName: cx(gdprClassName, inputAndGDPRWrapperClassName),
                                    gdprVisible: gdprVisible,
                                    gdprLabel: gdprLabel,
                                    gdprText: gdprText,
                                    gdprStyle: gdprStyle,
                                    uniqueId: uniqueId,
                                    componentColor: componentColor
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).submitButton,
                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                        className: cx((styles_module_default()).spinner),
                                        color: colors === null || colors === void 0 ? void 0 : colors[componentColor]
                                    }) : isInline ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        className: cx((styles_module_default()).submit, submitStyle, {
                                            textSubmit: textSubmit
                                        }),
                                        type: "submit"
                                    }, !textSubmit && {
                                        "aria-label": "newsletter-submit"
                                    }), {
                                        children: [
                                            !textSubmit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowRightIcon */.LZ, {
                                                className: cx((styles_module_default()).icon)
                                            }),
                                            textSubmit && t(dictionary/* FORM.SUBMIT */.Yc.SUBMIT)
                                        ]
                                    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquaredCta/* default */.Z, {
                                        className: cx((styles_module_default()).submit, submitStyle, {
                                            textSubmit: textSubmit
                                        }),
                                        type: "submit",
                                        theme: componentColor,
                                        withBackground: true,
                                        children: [
                                            !textSubmit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowRightIcon */.LZ, {
                                                className: cx((styles_module_default()).icon)
                                            }),
                                            textSubmit && t(dictionary/* FORM.SUBMIT */.Yc.SUBMIT)
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            type: "hidden",
                            name: "tags",
                            value: tags
                        }),
                        isInline && /*#__PURE__*/ (0,jsx_runtime.jsx)(GDPRLabels, {
                            gdprClassName: gdprClassName,
                            gdprVisible: gdprVisible,
                            gdprLabel: gdprLabel,
                            gdprText: gdprText,
                            gdprStyle: gdprStyle,
                            uniqueId: uniqueId,
                            componentColor: componentColor
                        }),
                        result && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: cx(resultClassName, (styles_module_default()).result, inputStyle),
                            children: result
                        })
                    ]
                })
            }))
        })
    });
}
Newsletter.defaultProps = {
    textSubmit: false,
    isInline: true
};
/* harmony default export */ var Form_Newsletter = (Newsletter);


/***/ }),

/***/ 64354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18357);
/* harmony import */ var _providers_RecaptchaProvider_use_google_recaptcha__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99778);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24627);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
function RecaptchaHandler(param) {
    var className = param.className, children = param.children;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__/* .useInView */ .YD)({
        initialInView: false
    }), 2), inViewRef = ref[0], inView = ref[1];
    var loadRecaptcha = (0,_providers_RecaptchaProvider_use_google_recaptcha__WEBPACK_IMPORTED_MODULE_3__/* .useGoogleReCaptcha */ .x)().loadRecaptcha;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (inView) loadRecaptcha();
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: inViewRef,
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().RecaptchaHandler), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().marker)
            }),
            children
        ]
    });
}
RecaptchaHandler.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (RecaptchaHandler);


/***/ }),

/***/ 97859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShopifyUpdateCustomerLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48228);
/* harmony import */ var _lib_handle_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16445);
/* harmony import */ var _hooks_useLang__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7078);
/* harmony import */ var _hooks_useOnMutationError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8414);









function useShopifyUpdateCustomerLocale(mutationOptions, setError) {
    var onMutationError = (0,_hooks_useOnMutationError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(setError);
    var lang = (0,_hooks_useLang__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
            var id;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = param.id;
                        return [
                            4,
                            (0,_lib_handle_api__WEBPACK_IMPORTED_MODULE_0__/* .requestNextApiEndpoint */ .m8)(_lib_handle_api__WEBPACK_IMPORTED_MODULE_0__/* .SHOPIFY_CUSTOMERS_UPDATE_LOCALE_PARAMS */ .po, {
                                payload: {
                                    id: id,
                                    locale: lang
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, mutationOptions), {
        onSuccess: function(data) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            var _mutationOptions;
            if (mutationOptions === null || mutationOptions === void 0 ? void 0 : mutationOptions.onSuccess) (_mutationOptions = mutationOptions).onSuccess.apply(_mutationOptions, [
                data
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(rest)));
        },
        onError: function(err) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            console.log(err);
            onMutationError(err, rest, mutationOptions === null || mutationOptions === void 0 ? void 0 : mutationOptions.onError);
        }
    }));
}


/***/ }),

/***/ 44955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1yMM0","input":"styles_input__0RNsU","submitButton":"styles_submitButton__A7G5m","spinner":"styles_spinner__ulZ5Y","submit":"styles_submit__fMC_w","textSubmit":"styles_textSubmit__iTeAM","gdpr":"styles_gdpr__uQPaU","gdprText":"styles_gdprText__Y_2JQ","visible":"styles_visible__C98tS","result":"styles_result__dv2jT","errorList":"styles_errorList__MUslm","isNotInline":"styles_isNotInline__Iz35M"};

/***/ }),

/***/ 24627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RecaptchaHandler":"styles_RecaptchaHandler__kL0nT","marker":"styles_marker__MNiHY"};

/***/ })

}]);